import { Popup } from 'components/Layout/Popup/Popup';
import { PERSOO_IDS } from 'modules/persoo/persooTypes';
import { ReactNode } from 'react';
import { twJoin } from 'tailwind-merge';
import twMerge from 'utils/twMerge';

type PopupLayoutProps = {
    heading: string | ReactNode;
    isPersooAllowed?: boolean;
    type?: 'success' | 'error' | 'info' | 'warning';
    hideCloseButton?: boolean;
    contentWrapperClassName?: string;
    onCloseCallback?: () => void;
};

export const PopupLayout: FC<PopupLayoutProps> = ({
    children,
    heading,
    isPersooAllowed,
    type = 'success',
    hideCloseButton = true,
    contentWrapperClassName,
    onCloseCallback,
}) => {
    return (
        <Popup
            className="w-[600px] max-w-[calc(100%-40px)] rounded-md bg-white p-0 vl:w-[1020px]"
            contentClassName="overflow-y-auto"
            hideCloseButton={hideCloseButton}
            onCloseCallback={onCloseCallback}
        >
            <h2
                className={twJoin(
                    'm-0 flex w-full flex-wrap items-center justify-center rounded-t-md px-5 pb-3 pt-4 !text-h5 normal-case leading-7 vl:!text-h3 vl:leading-8',
                    type === 'success' && 'bg-greenVeryLight text-greenDark',
                    type === 'error' && 'bg-redLight text-redDark',
                    type === 'info' && 'bg-grayVeryLight text-grayVeryDark',
                    type === 'warning' && 'bg-orangeLight text-grayVeryDark',
                )}
            >
                {heading}
            </h2>
            <div className={twMerge('px-5 py-10 vl:pb-11 vl:pl-14 vl:pr-12', contentWrapperClassName)}>{children}</div>
            {isPersooAllowed && <div id={PERSOO_IDS.prebasketCarousel} />}
        </Popup>
    );
};
